module.exports = __webpack_public_path__ + "static/img/HK@2x.a6aa3845.jpg";